import React, {Component} from "react";
import {OptionalTableCell} from "../../../shared/component/OptionalTableCell";

export class LoanDetailsTableLastName extends Component<{ lastName: string }> {
    render() {
        return <OptionalTableCell title='Last Name'>
            {this.props.lastName}
        </OptionalTableCell>;
    }
}